<template>
  <el-form
    ref="loginForm"
    :rules="rules"
    :model="form"
    size="medium"
    class="login-form"
    label-position="top"
    @submit.prevent
  >
    <el-form-item prop="username" :label="$t('main_login_account')">
      <el-input
        v-model="form.username"
        :placeholder="`${
          $t('main_login_placeholder_input') + accountMap[type] + $t('main_login_account')
        }`"
        @keyup.enter="onSubmit"
      ></el-input>
    </el-form-item>
    <el-form-item prop="password" :label="$t('main_login_password')">
      <el-input
        v-model="form.password"
        :type="isShow ? 'text' : 'password'"
        :placeholder="`${
          $t('main_login_placeholder_input') + accountMap[type] + $t('main_login_password')
        }`"
        @keyup.enter="onSubmit"
      >
        <template #append>
          <el-button class="toggle-view" @click="isShow = !isShow">
            <i :class="['iconfont', isShow ? 'el-icon-view' : 'el-icon-unview']"></i>
          </el-button>
        </template>
      </el-input>
    </el-form-item>
  </el-form>
  <div>
    <el-button type="text" @click="handleFindPassword"
      >{{ $t('main_login_retrieve_password') }}？</el-button
    >
  </div>
  <el-button type="primary" class="login-btn" :loading="submitLoading" @click="onSubmit">{{
    $t('main_login_btn_text')
  }}</el-button>
  <div class="login-privacy">
    <el-checkbox v-model="checkPrivacy">
      <span class="text">{{ $t('main_login_privacy_agree') }}</span>
    </el-checkbox>
    <span style="vertical-align: 2px;">
      <el-link
        type="primary"
        :href="TermsOfUseUrl"
        target="_blank"
        :underline="false"
      >
        {{ $t('main_login_privacy_title_1') }}
      </el-link>
      <span class="text">{{ $t('main_login_privacy_confirm') }}</span>
      <el-link
        type="primary"
        :href="PrivacyPolicyUrl"
        target="_blank"
        :underline="false"
      >
        {{ $t('main_login_privacy_title_2') }}
      </el-link>
    </span>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, watch, inject, h } from 'vue'
import { ElMessage, ElMessageBox, ElLink } from 'element-plus'
import { login } from '@/services/user'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

// import { getRoutes } from '@/router/index'

export default defineComponent({
  name: 'LoginForm',
  props: {
    type: String
  },
  setup(props) {
    const router = useRouter()
    // 获取 Vuex store 实例
    const store = useStore()
    const $t = inject('$t')

    const checkName = (rule, value, callback) => {
      if (!value.trim()) {
        callback(new Error($t('main_login_account_tip')))
      }
      callback()
    }
    const checkPassword = (rule, value, callback) => {
      if (!value.trim()) {
        callback(new Error($t('main_login_password_tip')))
      }
      callback()
    }
    const rules = {
      username: [{ validator: checkName, trigger: 'blur' }],
      password: [{ validator: checkPassword, trigger: 'blur' }]
    }

    const accountMap = {
      LDAP: $t('main_login_accountMap_LDAP'),
      SYS: $t('main_login_accountMap_SYS'),
      CAS: $t('main_login_accountMap_CAS'),
      AMS: $t('main_login_accountMap_SYS')
    }

    const form = reactive({
      username: '',
      password: ''
    })
    const submitLoading = ref(false)
    const isShow = ref(false)

    const loginForm = ref(null)
    const toLogin = inject('toLogin')

    // const onSubmit = async () => {
    //   try {
    //     await loginForm.value.validate()
    //     submitLoading.value = true
    //     form.username = form.username.trim()
    //     form.password = form.password.trim()
    //     const { data } = await login(form, 'AMS')
    //     await toLogin(data)
    //   } catch (error) {
    //     const { data } = await login(form, 'SYS')
    //     await toLogin(data)
    //     // if (error?.status === 404) {
    //     //   ElMessage.error($t('main_login_account_error'))
    //     // }
    //     console.dir(error)
    //   }
    //   submitLoading.value = false
    // }

    // 隐私政策
    const TermsOfUseUrl = ref(window.TermsOfUseUrl || '')
    const PrivacyPolicyUrl = ref(window.PrivacyPolicyUrl || '')
    const checkPrivacy = ref(false)
    const openPrivacy = () => {
      const linkAttr = {
        type: 'primary',
        target: '_blank',
        underline: false,
        style: {
          margin: '0 5px',
          verticalAlign: 'baseline'
        }
      }
      ElMessageBox({
        title: '',
        showClose: false,
        closeOnClickModal: false,
        showCancelButton: true,
        cancelButtonText: $t('main_login_privacy_think_btn'),
        confirmButtonText: $t('main_login_privacy_agree_btn'),
        message: h('div', null, [
          h('span', null, $t('main_login_privacy_tip')),
          h(ElLink, {
            ...linkAttr,
            href: TermsOfUseUrl.value
          }, $t('main_login_privacy_title_1')),
          h('span', null, $t('main_login_privacy_with')),
          h(ElLink, {
            ...linkAttr,
            href: PrivacyPolicyUrl.value
          }, $t('main_login_privacy_title_2'))
        ])
      }).then(() => {
        checkPrivacy.value = true
        onSubmit()
      })
    }

    const onSubmit = async () => {
      if (!loginForm.value) return // 确保表单表单引用存在

      try {
        // 验证表单数据
        await loginForm.value.validate()
        // 检验是否同意隐私
        if (!checkPrivacy.value) {
          openPrivacy()
          return
        }
        submitLoading.value = true

        // 去除表单数据前后的空格
        form.username = form.username.trim()
        form.password = form.password.trim()

        // 尝试登录
        const { data } = await login(form, 'AMS')
        await toLogin(data)
      } catch (error) {
        submitLoading.value = false
        // if (error?.status === 404) {
        //   ElMessage.error($t('main_login_account_error'))
        // }
        // 如果是其他错误，尝试第二次登录
        // try {
        //   const { data } = await login(form, 'SYS')
        //   await toLogin(data)
        // } catch (secondError) {
        //   if (secondError?.status === 404) {
        //     ElMessage.error($t('main_login_account_error'))
        //   }
        //   console.error('Login attempts failed:', error, secondError)
        // }
      }
    }

    watch(
      () => props.type,
      () => {
        form.username = ''
        form.password = ''
      }
    )

    const handleFindPassword = () => {
      const url = window.ForgetPasswordUrl || 'https://sit-glsso.eminxing.com/v2/cas/forgetPassword'
      window.open(url)
    }

    return {
      loginForm,
      form,
      rules,
      submitLoading,
      accountMap,
      isShow,
      checkPrivacy,
      TermsOfUseUrl,
      PrivacyPolicyUrl,
      onSubmit,
      handleFindPassword
    }
  }
})
</script>

<style lang="scss" scoped>
.login-form {
  .el-form-item {
    margin-bottom: 20px;

    .toggle-view {
      cursor: pointer;
      padding: 10px;
      box-sizing: border-box;

      &:hover {
        opacity: 0.5;
      }

      i {
        font-size: 26px;
      }
    }
  }
}

.login-btn {
  width: 100%;
  height: 40px;
  font-size: 14px;
  margin-top: 10px;
  border-radius: 6px;
  background: linear-gradient(90deg, rgba(252, 76, 2, 0.8) 0%, rgba(201, 60, 1, 0.8) 100%);
  border: none;
}

.login-privacy {
  margin-top: 10px;
  .text {
    color: var(--el-text-color-regular);
    font-size: 14px;
  }

  .el-link {
    margin: 0 5px;
    vertical-align: baseline;
  }
}
</style>
